import type { Getter } from "jotai";
import componentStackAtom from "./componentStackAtom";

export async function requestCurrentStackEntryClose(get: Getter) {
  const stack = get(componentStackAtom);
  const currentEntry = stack.at(-1);

  if (!currentEntry) {
    return true;
  }

  return currentEntry.controller.requestClose();
}
